import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import uk from './locales/uk.json';

const getStoredLanguage = () => {
  const urlLang = new URLSearchParams(window.location.search).get('lang');
  if (urlLang === 'en' || urlLang === 'uk') {
    localStorage.setItem('language', urlLang);
    return urlLang;
  }
  const stored = localStorage.getItem('language');
  if (stored === 'en' || stored === 'uk') {
    return stored;
  }
  localStorage.setItem('language', 'uk');
  return 'uk';
};

const initialLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    uk: { translation: uk },
  },
  lng: initialLanguage,
  fallbackLng: 'uk',
  supportedLngs: ['uk', 'en'],
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
